import { render, staticRenderFns } from "./RcpyES_RecPay.vue?vue&type=template&id=40bc99c0"
import script from "./RcpyES_RecPay.vue?vue&type=script&lang=js"
export * from "./RcpyES_RecPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports